import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@omilia/tooltip';

import { paginationOptionsType, dictionariesColumn } from 'types';
import Checkbox from 'components/Checkbox';
import EntriesSorter from './components/EntriesSorter';
import TableHeadColumn from './components/TableHeadColumn';
import './style.scss';

/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
const TableHead = ({
  columns,
  onToggleAllSelection,
  sortItems,
  isLoadingEntries,
  isAllSelected,
  isPartialSelected,
  entriesPagination,
  onAddColumn,
  onUpdateCol,
  onSaveNewColumn,
  onSaveColumnUpdate,
  onDeleteColumn,
}) => (
  <tr>
    <th styleName="select-wrap" data-test="select-rows">
      <Checkbox
        styleName="selection"
        type="checkbox"
        isSmall
        isChecked={isAllSelected}
        isPartialChecked={isPartialSelected}
        title="Select all entries to delete"
        onClick={onToggleAllSelection}
      />
    </th>

    <th>
      <div styleName="cell-wrap">
        <span styleName="order">A.</span>

        <span>Token</span>

        <EntriesSorter
          id="token"
          isLoadingEntries={isLoadingEntries}
          tooltipEnding="token"
          onSort={sortItems}
          sortBy={entriesPagination}
        />
      </div>
    </th>

    {columns.map(col => (
      <TableHeadColumn
        col={col}
        sortItems={sortItems}
        isLoadingEntries={isLoadingEntries}
        onUpdateCol={onUpdateCol}
        onSaveNewColumn={onSaveNewColumn}
        onSaveColumnUpdate={onSaveColumnUpdate}
        onDeleteColumn={onDeleteColumn}
        key={col.id || col.renderKey}
        entriesPagination={entriesPagination}
      />
    ))}

    <th styleName="add-new-wrap">
      <Tooltip placement="left" content="Add new column">
        <a styleName="button" onClick={onAddColumn} data-test="add-column">
          <i className="icon-add-testset-raw" />
        </a>
      </Tooltip>
    </th>
  </tr>
);

TableHead.propTypes = {
  columns: PropTypes.arrayOf(dictionariesColumn),
  isLoadingEntries: PropTypes.bool,
  sortItems: PropTypes.func.isRequired,
  onAddColumn: PropTypes.func.isRequired,
  onUpdateCol: PropTypes.func.isRequired,
  isAllSelected: PropTypes.bool,
  isPartialSelected: PropTypes.bool,
  onToggleAllSelection: PropTypes.func.isRequired,
  onSaveNewColumn: PropTypes.func.isRequired,
  onSaveColumnUpdate: PropTypes.func,
  onDeleteColumn: PropTypes.func.isRequired,
  entriesPagination: paginationOptionsType,
};

TableHead.defaultProps = {
  columns: [],
};

export default TableHead;
